import {defaultLeftSidebar, initialIntervalChanges, storage} from '../../constants/defaultValues'

import {
    CHANGE_LEFT_SIDEBAR, SET_FORM_DEBUG, SET_INTERVAL_CHANGES,
    SET_LAYOUT,
    SET_LOCALE
} from '../types'

const INIT_STATE_LEFT_SIDEBAR = (localStorage.getItem(storage.leftSidebar) && ['', 'collapsed'].filter(x => x === localStorage.getItem(storage.leftSidebar)).length > 0) ? localStorage.getItem(storage.leftSidebar) : defaultLeftSidebar

export const leftSidebar = (state = INIT_STATE_LEFT_SIDEBAR, action) => {
    switch (action.type) {
        case CHANGE_LEFT_SIDEBAR:
            localStorage.setItem(storage.leftSidebar, action.payload)
            return action.payload
        default:
            return state
    }
}

export const layout = (state = 0, action) => {
    switch (action.type) {
        case SET_LAYOUT:
            return action.payload
        default:
            return state
    }
}

export const locale = (state = "cs", action) => {
    switch (action.type) {
        case SET_LOCALE:
            return action.payload
        default:
            return state
    }
}

export const formDebug = (state = false, action) => {
    switch (action.type) {
        case SET_FORM_DEBUG:
            return action.payload
        default:
            return state
    }
}

export const intervalChanges = (state = initialIntervalChanges, action) => {
    switch (action.type) {
        case SET_INTERVAL_CHANGES:
            const changes = {...state, ...action.payload}

            Object.keys(changes).map(k => {
                if(changes[k]){
                    changes[k] = Math.random()
                }
            })

            return changes
        default:
            return state
    }
}

